import { useEffect, useRef } from 'react';
import { CurveGradientBg } from 'color4bg.js/build/jsm/CurveGradientBg.module.js';
import { useGPU } from '../../context/GPUContext';

const DEFAULT_COLORS = [
  ['#c86282', '#d89da5', '#db9aa7', '#e4b9c7', '#d9a1b5', '#c76182']
];

const CurveBackground = ({ activeIndex = 0 }) => {
  const canvasRefs = useRef([]);
  const containerRef = useRef(null);
  const { setGPUAcceleration } = useGPU();

  useEffect(() => {
    const container = containerRef.current;

    try {
      DEFAULT_COLORS.forEach((colors, i) => {
        const canvas = document.createElement('div');
        canvas.id = `curve-layer-${i}`;
        canvas.style.position = 'fixed';
        canvas.style.top = 0;
        canvas.style.left = 0;
        canvas.style.zIndex = -1;
        canvas.style.width = '150vw';
        canvas.style.height = '150vh';
        canvas.style.pointerEvents = 'none';
        canvas.style.transition = 'opacity 0.7s ease-in-out';
        canvas.style.opacity = i === activeIndex ? 1 : 0;

        container?.appendChild(canvas);

        const bg = new CurveGradientBg({
          dom: canvas.id,
          colors,
          loop: true,
          seed: 28198 + i,
        });

        canvasRefs.current[i] = bg;
        setGPUAcceleration(true); 
      });
    } catch (err) {
      console.error('CurveBackground failed:', err);
      setGPUAcceleration(false); 
    }

    return () => {
      canvasRefs.current.forEach((bg) => {
        try {
          bg?.dispose?.();
        } catch (e) {
          console.warn('Dispose failed for a background layer:', e);
        }
      });
    };
  }, []); 

  useEffect(() => {
    const children = containerRef.current?.children || [];
    [...children].forEach((el, i) => {
      el.style.opacity = i === activeIndex ? 1 : 0;
    });
  }, [activeIndex]);

  return <div ref={containerRef} />;
};

export default CurveBackground;
